(function () {
  const box = document.getElementById('FixelStockTiendas');
  const data = document.getElementById('FixelStockVariants');
  if (!box || !data) return;

  let variants;
  try { variants = JSON.parse(data.textContent); } catch (_) { return; }
  const body = box.querySelector('.fx-stock__body');
  let requestNumber = 0;

  // Las fichas nuevas usan el componente estándar; algunas fichas de Instant
  // conservan enlaces de compra propios. En ambos casos el bloque se coloca
  // inmediatamente antes de las acciones de compra.
  const standardBuy = document.querySelector('.product-info__add-to-cart');
  const instantBuy = [...document.querySelectorAll('a,button')]
    .find((el) => /Añadir al carrito/i.test(el.textContent || ''));
  const anchor = standardBuy || (instantBuy && instantBuy.parentElement && instantBuy.parentElement.parentElement);
  if (anchor && anchor.parentElement) anchor.insertAdjacentElement('beforebegin', box);

  const esc = (value) => String(value == null ? '' : value)
    .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;').replace(/'/g, '&#039;');

  function line(label, units, detail) {
    const available = Number(units) > 0;
    return '<div class="fx-stock__row">' +
      '<span class="fx-stock__dot ' + (available ? 'is-ok' : 'is-off') + '"></span>' +
      '<span><strong>' + esc(label) + '</strong><small>' + esc(detail) + '</small></span>' +
      '</div>';
  }

  function render(result) {
    if (!result.encontrado) {
      body.className = 'fx-stock__body';
      body.innerHTML = '<p class="fx-stock__notice">Consulta la disponibilidad de esta combinación con nuestro equipo.</p>';
      return;
    }
    const sb = Number(result.tiendas && result.tiendas.san_bernardo || 0);
    const bm = Number(result.tiendas && result.tiendas.bravo_murillo || 0);
    const provider = Number(result.proveedor || 0);
    const providerCompatible = Number(result.proveedorCompatible || 0);
    const bothStores = sb > 0 && bm > 0;
    body.className = 'fx-stock__body';
    body.innerHTML =
      line('San Bernardo', sb, sb ? 'Retirada inmediata · envío en 24–48 h' : 'No disponible ahora') +
      line('Bravo Murillo', bm, bm ? 'Retirada inmediata · envío en 24–48 h' : 'No disponible ahora') +
      line(
        'Foxway',
        provider || providerCompatible,
        provider ? 'Envío directo · 2–5 días hábiles' :
          providerCompatible ? 'Hay opciones · confirma el color · envío directo en 2–5 días hábiles' : 'No disponible ahora'
      ) +
      (bothStores
        ? '<p class="fx-stock__choice">Hay stock en las dos tiendas: podrás elegir dónde recogerlo.</p>'
        : '');
  }

  async function load(variant) {
    if (!variant) return;
    const current = ++requestNumber;
    body.className = 'fx-stock__body fx-stock__loading';
    body.textContent = 'Consultando stock...';
    const query = box.dataset.productTitle + ' ' + [variant.option1, variant.option2, variant.option3].filter(Boolean).join(' ');
    try {
      const response = await fetch(box.dataset.endpoint + '?v=2&q=' + encodeURIComponent(query));
      if (!response.ok) throw new Error('availability');
      const result = await response.json();
      if (current === requestNumber) render(result);
    } catch (_) {
      if (current === requestNumber) {
        body.className = 'fx-stock__body';
        body.innerHTML = '<p class="fx-stock__notice">No hemos podido consultar el stock. Escríbenos y te lo confirmamos.</p>';
      }
    }
  }

  const selectedId = new URLSearchParams(location.search).get('variant');
  load(variants.find((v) => String(v.id) === selectedId) || variants.find((v) => v.available) || variants[0]);
  document.addEventListener('on:variant:change', function (event) {
    if (event.detail && event.detail.variant) load(event.detail.variant);
  });
})();
